import React from "react";

import { IEmployeeWithoutGoalsDocument } from "@performyard/models";
import { Avatar, Link, Text } from "@performyard/py-components";

import { ScrollableColumn } from "../../../../../components/TableLite/TableLiteScrollable/TableLiteScrollable";

import toEmployeeUrl from "../../../../../utils/URLs/Employee";

const EmployeesWithoutGoalsCols = ({ groupsEnabled }: { groupsEnabled: boolean }): ScrollableColumn[] => {
	return [
		{
			label: "Employee",
			id: "name",
			getter: (row: IEmployeeWithoutGoalsDocument) => {
				const assigneeID = row._id;
				const assigneeName = row.name;
				return (
					<div className="h-8">
						<Link href={toEmployeeUrl(assigneeID)} forceHardReload underline="hover">
							<div className="flex h-full items-center gap-1">
								<Avatar size={20} id={assigneeID.toString()} />
								<div className="line-clamp-1">
									<Text size="paragraph-3" color="primary-5" weight="regular">
										{assigneeName}
									</Text>
								</div>
							</div>
						</Link>
					</div>
				);
			},
		},
		...(groupsEnabled
			? [
					{
						label: "Group",
						id: "department.name", // sorting needs to operate on the department.name field
						getter: (row: IEmployeeWithoutGoalsDocument) => {
							const departmentName = row.group ?? "";
							return (
								<div className="flex h-8 items-center">
									<div className="line-clamp-1">
										<Text size="paragraph-3" color="primary-9" weight="regular">
											{departmentName}
										</Text>
									</div>
								</div>
							);
						},
					},
				]
			: []),
		{
			label: "Manager",
			id: "manager.name", // sorting needs to operate on the manager.name field
			getter: (row: IEmployeeWithoutGoalsDocument) => {
				const managerID = row.manager?._id;
				const managerName = row.manager?.name;
				return (
					<div className="h-8">
						{managerID ? (
							<Link href={toEmployeeUrl(managerID)} forceHardReload underline="hover">
								<div className="flex h-full items-center gap-1">
									<Avatar size={20} id={managerID.toString()} />
									<div className="line-clamp-1">
										<Text size="paragraph-3" color="primary-5" weight="regular">
											{managerName}
										</Text>
									</div>
								</div>
							</Link>
						) : null}
					</div>
				);
			},
		},
	];
};

export default EmployeesWithoutGoalsCols;
